import { AND, NOT, OR } from 'utils/combinatorTypes';
import { Rules } from '../types';

enum Combinator {
  Or = 'Or',
  And = 'And',
  Not = 'Not',
}

export const combinators = [Combinator.And, Combinator.Not, Combinator.Or];
export const makeOption = (value: string, text: string, description: string) => ({
  value,
  text,
  description,
  id: value,
  label: text,
});

const ANY = makeOption(Combinator.Or, 'any', 'OR');
const ALL = makeOption(Combinator.And, 'all', 'AND');
const NONE = makeOption(Combinator.Not, 'none', 'NOT');

export const combinatorOptions = [ANY, ALL, NONE];

export const combinatorToOptionsIndex = (combinator: string) => {
  if (combinator === Combinator.Or) return 0;
  if (combinator === Combinator.And) return 1;
  if (combinator === Combinator.Not) return 2;
  return 1;
};

export function isFirstRuleFilledOut(rules: Rules) {
  // accd. to product team, a "filled out rule" is one where nothing has been filled out rule-wise, but the user pressed a button to get started on it.
  if (rules?.[0]?.childRules?.length === 0) return false;
  return true;
}

export function getCombinatorCopy(combinator: string) {
  let combinatorDescriptor = 'or';
  switch (combinator) {
    case AND:
      combinatorDescriptor = 'and';
      break;
    case OR:
      combinatorDescriptor = 'or';
      break;
    case NOT:
      combinatorDescriptor = 'nor';
      break;
    default:
      // leave at or. shouldn't happen unless a new combinator is added
      break;
  }

  return combinatorDescriptor;
}
